"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentManager = useDocumentManager;
const helpers_1 = require("@core/helpers");
const notifications_manager_1 = require("@core/managers/notifications.manager");
const tracking_manager_1 = require("@core/managers/tracking.manager");
const posthog_manager_1 = require("@core/managers/posthog.manager");
const common_1 = require("@core/constants/common");
const core_v2_1 = require("@extracadabra/core-v2");
const vue_1 = require("vue");
function useDocumentManager(documentManagerRepository) {
    const DOCUMENTS_PAGE_SIZE = 24;
    const selected = (0, vue_1.ref)([]);
    const isYearsLoading = (0, vue_1.ref)(false);
    const isDocumentsLoading = (0, vue_1.ref)(false);
    const isDownloadDocumentLoading = (0, vue_1.ref)(false);
    const jobYears = (0, vue_1.ref)([]);
    const currentYear = (0, vue_1.ref)();
    const sortBy = (0, vue_1.ref)(core_v2_1.SortBy.Descendant);
    const currentTotalPerPage = (0, vue_1.ref)(0);
    const allDocumentsFromCurrentYearSelected = (0, vue_1.ref)(false);
    const selectedFilters = (0, vue_1.ref)([]);
    const filterOptions = (0, vue_1.ref)([]);
    const getSumUp = async (app) => {
        return (await new core_v2_1.GetSumUp(documentManagerRepository).execute(app));
    };
    const getjobYears = async (documentType) => {
        isYearsLoading.value = true;
        const jobYears = await new core_v2_1.GetJobYears(documentManagerRepository).execute(core_v2_1.Applications.Etablissement, documentType);
        isYearsLoading.value = false;
        return jobYears;
    };
    const showCheckboxes = (isGreaterThanMobile) => {
        return isGreaterThanMobile;
    };
    const hasPagination = (totalItems, pageSize) => {
        return totalItems > pageSize;
    };
    const getDocuments = async (app, documentType, params) => {
        return await new core_v2_1.GetDocumentsPerYear(documentManagerRepository).execute(documentType, app, params);
    };
    const getAllDocumentsIds = async (year, documentType) => {
        return await new core_v2_1.GetMultipleDocumentsIds(documentManagerRepository).execute(documentType, core_v2_1.Applications.Etablissement, year);
    };
    const downloadSelectedDocuments = async (app, documentType, ids) => {
        try {
            const data = await new core_v2_1.DownloadDocuments(documentManagerRepository).execute(documentType, app, ids);
            const file = await helpers_1.EncodingHelpers.getBase64FromFile(data);
            (0, core_v2_1.downloadBase64Zip)(file, "documents", "zip");
            tracking_manager_1.TrackingManager.addEvent({
                event: core_v2_1.DocumentEvent.DOWNLOAD_MULTIPLE_DOCUMENTS,
                params: documentType,
            });
            posthog_manager_1.PosthogManager.captureEvent(common_1.DOCUMENTS_MANAGER_POSTHOG_EVENTS, {
                name: core_v2_1.DocumentEvent.DOWNLOAD_MULTIPLE_DOCUMENTS,
                type: documentType,
            });
        }
        catch (error) {
            notifications_manager_1.NotificationsManager.error();
            posthog_manager_1.PosthogManager.captureEvent(common_1.DOCUMENTS_MANAGER_POSTHOG_EVENTS, {
                name: core_v2_1.DocumentEvent.DOWNLOAD_MULTIPLE_DOCUMENTS_ERROR,
                type: documentType,
            });
        }
    };
    const shouldDisplaySelectAllButton = (documents, year, pageSize = DOCUMENTS_PAGE_SIZE, isMobileScreen = false) => {
        var _a;
        return isMobileScreen && ((_a = documents[year]) === null || _a === void 0 ? void 0 : _a.total) && documents[year].total > pageSize;
    };
    const resetSelection = () => {
        allDocumentsFromCurrentYearSelected.value = false;
        selected.value = [];
    };
    return {
        jobYears,
        currentYear,
        currentTotalPerPage,
        sortBy,
        allDocumentsFromCurrentYearSelected,
        filterOptions,
        selectedFilters,
        selected,
        isYearsLoading,
        isDocumentsLoading,
        isDownloadDocumentLoading,
        hasPagination,
        getDocuments,
        getjobYears,
        getSumUp,
        getAllDocumentsIds,
        shouldDisplaySelectAllButton,
        showCheckboxes,
        downloadSelectedDocuments,
        resetSelection,
    };
}
